export default __webpack_public_path__ + "static/media/G0000.cc6e3b7c.png";